import { Routes, Route, Navigate } from 'react-router-dom'
import LoginPage from './pages/Login/LoginPage'
import CallbackPage from './pages/Auth/CallbackPage'
import DashboardPage from './pages/Dashboard/DashboardPage'
import { ETLPage } from './pages/ETL'
import RecvizConfiguratorPage from './pages/Recviz/RecvizConfiguratorPage'
import { OrgRefsPage, RecvizResultPage } from './pages/Org'
import NsiTfomsProfilesPage from './pages/Admin/NsiTfomsProfilesPage'
import BaseTariffsPage from './pages/Admin/BaseTariffsPage'
import UsersPage from './pages/Admin/UsersPage'
import AdminAccessWorkspacePage from './pages/Admin/AdminAccessWorkspacePage'
import DashboardAccessWorkspacePage from './pages/Admin/DashboardAccessWorkspacePage'
import DashboardTemplateRegistryPage from './pages/Admin/DashboardTemplateRegistryPage'
import DashboardPublicationsPage from './pages/Admin/DashboardPublicationsPage'
import BiWorkspacePage from './pages/Admin/BiWorkspacePage'
import AccessGroupsPage from './pages/Admin/AccessGroupsPage'
import AccessGroupDetailPage from './pages/Admin/AccessGroupDetailPage'
import AdminDashboardPage from './pages/Admin/AdminDashboardPage'
import AuditLogPage from './pages/Admin/AuditLogPage'
import OrganizationsPage from './pages/Admin/OrganizationsPage'
import AccessHealthPage from './pages/Admin/AccessHealthPage'
import LpuAccessMatrixPage from './pages/Admin/LpuAccessMatrixPage'
import PlatformRbacPage from './pages/Admin/PlatformRbacPage'
import InviteLandingPage from './pages/Invite/InviteLandingPage'
import MainLayout from './components/Layout/MainLayout'
import ProtectedRoute from './components/ProtectedRoute'
import { useAuthStore } from './store/auth'

function App() {
  const sessionKey = useAuthStore((state) =>
    `${state.user?.id ?? 'anon'}:${state.user?.role ?? 'none'}:${state.user?.email ?? 'unknown'}`
  )

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<CallbackPage />} />
      <Route path="/invite/:token" element={<InviteLandingPage />} />

      <Route
        path="/*"
        element={
          <ProtectedRoute requireAdminPortal>
            <MainLayout key={sessionKey}>
              <Routes>
                <Route path="/" element={<DashboardPage />} />

                {/* Маршруты /org */}
                <Route path="/org/structure" element={<ETLPage />} />
                <Route path="/org/bed-fund" element={<ETLPage />} />
                <Route path="/org/refs" element={<OrgRefsPage />} />
                <Route path="/org/configurator" element={<RecvizConfiguratorPage />} />
                <Route path="/org/recviz-result" element={<RecvizResultPage />} />
                <Route path="/etl/file-intake" element={<ETLPage initialTab="file-intake" />} />

                {/* Администрирование — требует superadmin или org_admin */}
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute requiredCapability="adminAccess">
                      <AdminDashboardPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/users"
                  element={
                    <ProtectedRoute requiredCapability="adminAccess">
                      <UsersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/access-workspace"
                  element={
                    <ProtectedRoute requiredCapability="adminAccess">
                      <AdminAccessWorkspacePage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/dashboard-access-workspace"
                  element={
                    <ProtectedRoute requiredCapability="adminAccess">
                      <DashboardAccessWorkspacePage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/bi-workspace"
                  element={
                    <ProtectedRoute requiredCapability="adminAccess">
                      <BiWorkspacePage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/dashboard-template-registry"
                  element={
                    <ProtectedRoute requiredCapability="superadminAccess">
                      <DashboardTemplateRegistryPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/dashboard-publications"
                  element={
                    <ProtectedRoute requiredCapability="superadminAccess">
                      <DashboardPublicationsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/access-groups"
                  element={
                    <ProtectedRoute requiredCapability="adminAccess">
                      <AccessGroupsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/access-groups/:id"
                  element={
                    <ProtectedRoute requiredCapability="adminAccess">
                      <AccessGroupDetailPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/nsi-tfoms-profiles"
                  element={
                    <ProtectedRoute requiredCapability="superadminAccess">
                      <NsiTfomsProfilesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/base-tariffs"
                  element={
                    <ProtectedRoute requiredCapability="superadminAccess">
                      <BaseTariffsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/audit"
                  element={
                    <ProtectedRoute requiredCapability="adminAccess">
                      <AuditLogPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/orgs"
                  element={
                    <ProtectedRoute requiredCapability="orgsRead">
                      <OrganizationsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/access-health"
                  element={
                    <ProtectedRoute requiredCapability="adminAccess">
                      <AccessHealthPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/platform-rbac"
                  element={
                    <ProtectedRoute requiredCapability="platformRbacRead">
                      <PlatformRbacPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/lpu/:code/access-matrix"
                  element={
                    <ProtectedRoute requiredCapability="adminAccess">
                      <LpuAccessMatrixPage />
                    </ProtectedRoute>
                  }
                />

                {/* Редиректы со старых путей */}
                <Route path="/etl" element={<Navigate to="/org/structure" replace />} />
                <Route path="/recviz" element={<Navigate to="/org/configurator" replace />} />
                <Route path="/refs/filials" element={<Navigate to="/org/refs" replace />} />
                <Route path="/refs/services" element={<Navigate to="/org/refs" replace />} />
                <Route path="/refs/departments" element={<Navigate to="/org/refs" replace />} />
                <Route path="/refs/plan-indicators" element={<Navigate to="/org/refs" replace />} />

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default App
